var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/hooks/navigation-eventlog.ts
import { A } from "@adornis/base/env-info.js";
import { Entity } from "@adornis/baseql/decorators.js";
import { EventLog } from "../eventlog.js";
var NavigationEventlog = class extends EventLog {
  sendToAnalytics() {
    if (!A.isClient)
      return;
    if (!window.gtag)
      return;
    console.log("ANALYTICS::sendNavigation", this.route ? { url: this.route } : void 0);
    window.gtag("event", "page_view", {
      page_title: "Page title",
      page_location: location.href,
      page_path: location.pathname
    });
  }
};
NavigationEventlog._class = "NavigationEventlog";
NavigationEventlog = __decorateClass([
  Entity()
], NavigationEventlog);
export {
  NavigationEventlog
};
